<template>
  <div class="box">
    <div class="clear">
      <ul class="head-nav" :style="{border: `1px solid ${color}`}">
        <li @click="setActiveTime(item,i)" v-for="(item,i) in dataInfo">
          <div v-if="i === activeTimeIndex" :style="activeTimeTabStyle">
            {{item.date}}
          </div>
          <div v-if="i !== activeTimeIndex && i !==dataInfo.length-1" :style="normalTimeTabStyle">
            {{item.date}}
          </div>
          <div v-if="i !== activeTimeIndex && i ===dataInfo.length-1" :style="lastTimeTabStyle">
            {{item.date}}
          </div>
        </li>
      </ul>
      <div @click="search" :style="{backgroundColor: color,color:'#ffffff',cursor: 'pointer',padding: '0 3px'}" class="search">
        <img style="vertical-align: middle;" src="../../../common/imgs/search.png" alt="">
        {{ $t("message.search") }}
      </div>
    </div>
    <div class="clear" style="margin-top: 44px;" v-if="activeTimeIndex!=null">
      <div class="room-box">
        <!--<div class="room-head" :style="{borderColor: color,color: color}">-->
          <!--<img style="height: 15px; vertical-align: middle;" src="./room_icon.png" alt="">-->
          <!--<span style="vertical-align: middle;">会议室</span>-->
        <!--</div>-->
        <!--<div style="width: 2px;height: 8px;" :style="{backgroundColor: color,boderColor: `${color}`}"></div>-->
        <ul class="rooms"
            :style="{borderColor: `${color}`}">
          <li @click="setRoom(item,i)" class="item-nav" :style="{borderColor: `${color}`}" v-for="(item,i) in roomNameStatus">
            <!--<p>{{activeRoomsIndex}} {{item.abled}}</p>-->
            <div v-show="activeRoomsIndex === i && item.abled == true" :style="activeRoomTabStyle">
              {{item.name}}
            </div>
            <div v-show="activeRoomsIndex !== i && item.abled == true" :style="normalRoomTabStyle">
              {{item.name}}
            </div>
            <div v-show="item.abled == false" style="color: #b7b7b7;">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
      <div class="day-box">
        <!--<div class="day-head">-->
          <!--<div style="width: 143px;">时间</div>-->
          <!--<div style="width: 471px;">主题</div>-->
          <!--<div style="width: 212px;">嘉宾/讲者</div>-->
        <!--</div>-->
        <div class="day-body">
          <ul>
            <li class="daily-box" v-for="(item,i) in activeDayData.calendars" :key="i">
              <!--一级日程-->
              <div>
                <div class="title first" :style="{
                  borderWidth: 
                  0
                }">
                  <h3>
                    <img style="width: 16px;" src="../../../common/imgs/book.svg" alt="">
                    <span>{{item.calTitle}}</span>
                  </h3>
                  <h3>
                    <img style="width: 16px;" src="../../../common/imgs/clock.svg" alt="">
                    <span>{{item.calStart}} - {{item.calEnd}}</span>
                  </h3>
                </div>
                
                <div
                  :style="{borderWidth: item.subCals.length===0 && item.speakers.length===0 ? '0': '2px'}"
                  v-if="item.chairman.length || item.hosts.length || item.commenter.length || item.translater.length || item.speakers.length" class="first">
                  <p v-if="item.chairman.length">
                    <span class="img-style">
                      <!-- <img style="width: 12px;" src="../../../common/imgs/people.svg" alt=""> -->
                      {{ $t("message.tpl1.daily.zhuxi") }}:
                    </span>
                    <span class="jia-bin" v-for="(zx,k) in item.chairman" :key="k">{{zx.uName}}</span></p>
                  <p v-if="item.hosts.length">
                    <span class="img-style">
                      <!-- <img style="width: 12px;" src="../../../common/imgs/ht.svg" alt=""> -->
                      {{ $t("message.tpl1.daily.zhuchi") }}:
                    </span>
                    <span v-for="(calhost,h) in item.hosts" :key="h" class="jia-bin">{{calhost.uName}}</span>
                  </p>
                  <p v-if="item.commenter.length">
                    <span class="img-style">
                      <!-- <img style="width: 12px;" src="../../../common/imgs/ht.svg" alt=""> -->
                      {{ $t("message.tpl1.daily.dianping") }}:
                    </span>
                    <span v-for="(c,h) in item.commenter" :key="h" class="jia-bin">{{c.uName}}</span>
                  </p>
                  <p v-if="item.translater.length">
                    <span class="img-style">
                      <!-- <img style="width: 12px;" src="../../../common/imgs/ht.svg" alt=""> -->
                      {{ $t("message.tpl1.daily.fanyi") }}:
                    </span>
                    <span v-for="(t,h) in item.translater" :key="h" class="jia-bin">{{t.uName}}</span>
                  </p>
                  <p v-if="item.speakers.length>0">
                    <span class="img-style">
                      <!-- <img style="width: 12px;" src="../../../common/imgs/message.svg" alt=""> -->
                      {{ $t("message.tpl1.daily.teacher") }}:
                    </span>
                    <span  class="jia-bin" v-for="(speak,j) in item.speakers" :key="j">{{speak.uName}}</span>
                  </p>
                </div>
                <div>

                  <div class="secend-day" v-for="(cal,j) in item.subCals" :key="j">
                    <div>
                      <h2 style="position: relative;">
                        <span class="s-tips"><b></b></span>
                        <span class="circle"></span>
                        {{cal.calTitle}}
                      </h2>
                      <p>
                        <span class="bold" style="margin-left: 10px;">
                          {{cal.calStart}}-{{cal.calEnd}}
                        </span>
                        <span v-if="cal.calSpeaker" class="img-style">
                          <!-- <img style="width: 12px;" src="../../../common/imgs/message.svg" alt=""> -->
                          {{ $t("message.tpl1.daily.teacher") }}:
                        </span>
                        <span  v-if="cal.calSpeaker" class="bold">{{cal.calSpeaker}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        activeTimeIndex: null,
        activeRoomsIndex: 0,
        curActiveRoomIndex: 0, //当前的时间，房间对应的日程数据
      }
    },
    props: {
      color: {
        type: String,
        defulat: () => {
          return '#f39800'
        }
      },
      dataInfo: {
        required: true
      }
    },
    mounted () {
         let activeTime
         let activeRoom
         this.dataInfo.map((item,index)=>{
         if(item.date_def_fl == 1){
            activeTime=index;
          }
          item.rooms.map((roomItem,roomIndex)=>{
            if(roomItem.room_def_fl == '1'){
              activeRoom = roomIndex
            }
          })
        })
       this.activeTimeIndex = activeTime
       this.activeRoomsIndex = activeRoom
       this.curActiveRoomIndex = this.activeRoomsIndex
    },
    computed: {
//      使房间具有状态
      // activeTimeIndex(){
      //   let activeTime
      //    this.dataInfo.map((item,index)=>{
      //    if(item.date_def_fl == 1){
      //       activeTime=index;
      //   }
      // })
      //  return activeTime
      // },
      roomNameStatus(){
        console.log(this.allRoomNames);
        let results = [];
        let activeTimeData = this.dataInfo[this.activeTimeIndex];
        let allrooms = this.allRoomNames;
        let rooms = activeTimeData.rooms;
        for (let i = 0; i < allrooms.length; i++) {
          for (let j = 0; j < rooms.length; j++) {
            if (allrooms[i].name === rooms[j].name) {
              allrooms[i].abled = true;
              allrooms[i].index = j;  
              break;
            } else {
              allrooms[i].abled = false;
              allrooms[i].index = '';
            }
          }
          results.push(allrooms[i]);
        }
        return results;
      },
//        获得所有的厅
      allRoomNames(){
        let tempArr = [];
        let rooms = [];
        this.dataInfo.map((item, i) => {
          item.rooms.map((room, j) => {
            if (tempArr.indexOf(room.name) === -1) {
              let obj = {
                abled: true,
                name: room.name,
                roomorder:room.roomorder
              };
              rooms.push(obj);
              tempArr.push(room.name);
            }
          })
        });
        console.log(rooms)
        let ar = rooms.sort(this.compare('roomorder'))
        console.log(ar)
        return ar;
      },
     
      activeTimeTabStyle(){
        return {
          backgroundColor: this.color,
          color: '#ffffff'
        }
      },
      normalTimeTabStyle(){
        return {
          backgroundColor: "#ffffff",
          color: this.color,
          borderRight: `1px solid ${this.color}`
        }
      },
      lastTimeTabStyle(){
        return {
          backgroundColor: "#ffffff",
          color: this.color,
          borderRight: `0`
        }
      },
      activeRoomTabStyle(){
        return {
          backgroundColor: this.color,
          color: '#ffffff'
        }
      },
      normalRoomTabStyle(){
        return {
//          backgroundColor: '#ffffff',
          color: this.color
        }
      },
      notabledRoomTabStyle(){

      },
      activeDayData(){
        return this.dataInfo[this.activeTimeIndex].rooms[this.curActiveRoomIndex]
      }
    },
    methods: {
       compare(property){
         return function(obj1,obj2){
             var value1 = obj1[property];
             var value2 = obj2[property];
             return value1 - value2;     // 升序
         }
      },
      search(){
        this.$emit('search',this.dataInfo)
      },
      setActiveTime(item, index){
        this.activeTimeIndex = index;
//        this.curActiveRoomIndex  = 0;
        for (let i = 0; i < this.roomNameStatus.length; i++) {
          let curRoomStatus = this.roomNameStatus[i];
          if (curRoomStatus.abled && curRoomStatus.index !=='') {
//            this.curActiveRoomIndex = i;
            this.activeRoomsIndex = curRoomStatus.index;
            this.curActiveRoomIndex = curRoomStatus.index;
            break;
          }
        }
      },
      setRoom(item, i){
        if (!item.abled) return;
        this.activeRoomsIndex = i;
        this.curActiveRoomIndex = item.index;
      }
    }
  }
</script>
<style scoped lang="less">
  .box {
  }
/*日程*/
  .daily-box{
    border: 2px solid #959595;
    margin-bottom: 10px;
    img{
      vertical-align: middle;
      margin-top: -2px;
    }
    .img-style{
      /* background-color: #F19149; */
      color: #333333;
      padding: 2px 4px;
      margin-right: 12px;
      font-size: 14px;
    }
    .circle{
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #959595;
      vertical-align: middle;
      margin-right: 2px;
    }
    .s-tips{
      position: absolute;
      left: -20px;
      top: 5px;
      border: 10px solid #959595;
      border-right-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
      b{
        position: absolute;
        left: -14px;
        top: -10px;
        border: 10px solid #ffffff;
        border-right-color: transparent;
        border-top-color: transparent;
        border-bottom-color: transparent;
      }
    }
    .first{
      background-color: #f7f7f7;
      padding: 10px;
      // border-bottom: 2px solid #959595;
      line-height: 2;
      font-size: 14px;
      .zhu-xi{
        margin-right: 12px;
      }
      h3{
        font-size: 15px;
        color: #000000;
      }
      .jia-bin{
        font-weight: bold;
        margin-right: 12px;
      }
      &:first-child{
        border-bottom-width: 1px;
      }
    }
    .secend-day{
      font-size: 14px;
      padding: 10px 20px;
      line-height: 2;
      border-bottom: 1px solid #959595;
      &:last-child{
        border: 0;
      }
      .bold{
        font-weight: bold;
        margin-right: 12px;
      }
    }
  }
  .head-nav {
    display: table;
    width: 899px;
    line-height: 40px;
    float: left;
    li {
      cursor: pointer;
      display: table-cell;
      text-align: center;
      font-size: 15px;
      &:last-child {
        border-right: 0 !important;
      }
    }
  }

  .search {
    float: left;
    height: 40px;
    background: red;
    text-align: center;
    line-height: 40px;
    font-size: 15px;
    color: #ffffff;
    width: 90px;
    margin-left: 11px;
  }

  .room-box {
    float: left;
    width: 180px;
  }

  .day-box {
    float: left;
    margin-left: 31px;
    /*border: 1px solid #f5f5f5;*/
    width: 788px;
  }

  .room-head {
    border: 2px solid red;
    line-height: 27px;
    border-top-right-radius: 8px;
    text-align: center;
    font-size: 15px;
  }

  .rooms {
    border-width: 2px;
    border-bottom-width: 1px;
    border-left-width: 2px;
    border-style: solid;
    li {
      line-height: 40px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .day-head {
    display: table;
    background: #F2EDED;
    color: #000000;
    line-height: 30px;
    & > div {
      display: table-cell;
      text-align: center;
      border-right: 1px solid #f5f5f5;
      &:last-child {
        border-right: 0;
      }
    }
  }

/*  .day-body {
    font-size: 14px;
    color: #000000;
    li {
      display: table;
      & > div {
        display: table-cell;
      }
    }
    .time {
      box-sizing: border-box;
      padding: 20px;
      font-size: 16px;
      .time1 {
        font-size: 16px;
        line-height: 40px;
      }
      .time2 {
        font-size: 14px;
        line-height: 30px;
        float: right;
      }
    }
    .day-title {
      position: relative;
      padding-left: 25px;
      border-right: 1px solid #f5f5f5;
      .line {
        position: absolute;
        left: 0;
        width: 1px;
        height: 100%;
        top: -4px;
      }
      .title1 {
        font-size: 15px;
        line-height: 40px;
        position: relative;
        b {
          border: 1px solid red;
          border-radius: 50%;
          display: block;
          position: absolute;
          left: -34px;
          top: 10px;
          i {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            display: block;
            margin: 2px;
          }
        }
      }
      .title2 {
        padding-left: 10px;
        font-size: 14px;
        line-height: 30px;
        position: relative;
        b {
          display: block;
          background-color: #B5B5B5;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: absolute;
          left: -15px;
          top: 11px;
        }
        .s1 {
          display: inline-block;
          border: 8px solid red;
          width: 0;
          height: 0;
          background: transparent;
          border-radius: 0;
          border-top-color: transparent;
          border-right-color: transparent;
          border-bottom-color: transparent;
          position: absolute;
          left: -25px;
          top: 7px;
        }
        .s2 {
          border-left-color: #ffffff;
          left: -27px;
          z-index: 10;
        }
      }
    }
    .teacher {
      text-align: center;
      .title1 {
        font-size: 16px;
        line-height: 40px;
      }
      .title2 {
        font-size: 14px;
        line-height: 30px;
      }
    }
  }*/
  .item-nav{
    border-style: solid;
    border-bottom-width: 1px;
  }
  .item-nav:last-child{
    border-bottom-width: 2px;
  }
</style>



// WEBPACK FOOTER //
// daily.vue?4373f041